module.exports = __webpack_public_path__ + "img/Desconhecida.82a3fd0d.svg";